import React from 'react'
import {AppBar as AppBarUI, Toolbar} from '@material-ui/core';
import InvertColorsButton from './InvertColorsButton';
import TextSizeButton from './TextSizeButton';
import Profile from './Profile';
import PolandSvg from 'images/Poland'
import GreatBritainSvg from 'images/GreatBritain'
import {connect} from 'react-redux'
import GridBlock from 'components/GridBlock';
import clsx from 'clsx';
import Tr from 'translations/Translations';
import Button from 'components/Button';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import Endpoints from 'constants/Endpoints';
import {makeStyles} from "@material-ui/core/styles";
import {withRouter} from "react-router";
import Help from "../../popup/help/Help";
import ChangeLanguageButtonButtons from "./ChangeLanguageButtonButtons";
import redirectUsingPOST from "libs/redirectUsingPOST";

const useStyle = makeStyles(theme => ({
    root: {
        paddingLeft: theme.components.navigation.margin.left,
        zIndex: theme.zIndex.appBar + 10,
        borderBottom: `solid 3px ${theme.palette.primary.main}`,
        backgroundColor: theme.palette.background.greyBackground,
    },
    rootBorder: {},
    menuMargin: {
        paddingLeft: theme.components.navigation.width,
        transition: theme.transitions.default.open('margin-left'),
    },
    toolbar: {
        justifyContent: 'space-between'
    },
    rightGrid: {
        width: 'unset'
    },
    beta: {
        paddingLeft: theme.spacing(1),
        color: theme.palette.primary.contrastText
    },
    buttonLight: {
        whiteSpace: 'nowrap',
        marginRight: theme.spacing(1),
    },
    logo: {
        maxHeight: 55,
        maxWidth: 200
    }
}))

function AppBar(
    {
        logo = {},
        isMenuOpen,
        demandHeader,
        id,
        location
    }) {

    const classes = useStyle();
    const goSoStatus = !!(demandHeader?.oldPlatformRoundStatusUrl);

    const handleRedirectToOldSystemVersion = () => {
        if (goSoStatus) {
            window.location.href = demandHeader.oldPlatformRoundStatusUrl;
        } else {
            window.location.href = Endpoints.SERVER_URL;
        }
    };

    const changeLocale = (locale) => {
        const split = locale.split("_");
        const auth = JSON.parse(localStorage.getItem("authorize"));
        const url = Endpoints.CHANG_LANGUAGE(split[0], split[1], auth.csrf, window.location.href);
        redirectUsingPOST(url);
    }

    return (
        <AppBarUI
            id={id}
            className={clsx(classes.root, {
                [classes.menuMargin]: isMenuOpen,
                [classes.rootBorder]: !demandHeader
            })}
            elevation={0}
            position='sticky'
        >
            <Toolbar
                className={classes.toolbar}
            >
                <GridBlock alignItems="center">
                    <img
                        className={classes.logo}
                        src={logo.url}
                        alt='logo'
                    />
                    {/*<Typography className={classes.beta} variant="body1">{Tr("beta_version")}</Typography>*/}
                </GridBlock>
                <GridBlock
                    wrap='nowrap'
                    className={classes.rightGrid}
                    alignItems='center'
                >
                    <Button
                        size='small'
                        onClick={handleRedirectToOldSystemVersion}
                        color='secondary'
                        className={classes.buttonLight}
                        variant='text'
                    >
                        <SwapHorizIcon/>
                        {Tr(goSoStatus ? 'redirectToOldVersionStatus' : 'redirectToOldVersion')}
                    </Button>
                    <Help/>
                    <TextSizeButton/>
                    <InvertColorsButton/>
                    {/* <Avatar /> */}
                    <ChangeLanguageButtonButtons Icon={PolandSvg} locale={"pl_PL"} setLocale={changeLocale}/>
                    <ChangeLanguageButtonButtons Icon={GreatBritainSvg} locale={"en_EN"} setLocale={changeLocale}/>
                    <Profile/>
                </GridBlock>
            </Toolbar>
        </AppBarUI>
    )
}

export default connect((state) => ({
    logo: state.resources.logo,
    isMenuOpen: state.store.isMenuOpen,
    demandHeader: state.resources.demandHeader,
}), {})(withRouter(AppBar));
